/** Minimal placeholder asset used when placing an image card before upload. */
export const createPlaceholderImageFile = (): Promise<File> =>
  new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    canvas.width = 8
    canvas.height = 8
    const context = canvas.getContext('2d')
    if (!context) {
      reject(new Error('Canvas not supported'))
      return
    }

    context.fillStyle = '#eeeeee'
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.strokeStyle = '#9e9e9e'
    context.lineWidth = 1
    context.strokeRect(0.5, 0.5, canvas.width - 1, canvas.height - 1)

    canvas.toBlob(blob => {
      if (!blob) {
        reject(new Error('Failed to create placeholder image'))
        return
      }
      resolve(new File([blob], 'plan-image-card-placeholder.png', { type: 'image/png' }))
    }, 'image/png')
  })
